import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = new Set(['/login', '/auth-redirect']) // no redirect whitelist

function redirectToLogin (next, to) {
  next(`/login?redirect=${to.path}`)
  NProgress.done()
}

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  if (to.path === '/login') {
    next()
    return;
  }

  if (to.path.indexOf('/wholesale/') === 0) {
    document.title = to.meta.title;
    next()
    return;
  }

  // determine whether the user has logged in
  const hasLogin = await store.dispatch('user/checkLogin');
  const hasAccountSet = hasLogin
    ? await store.dispatch('user/checkAccountSet')
    : false;
  if (hasLogin && hasAccountSet) {
    // determine whether the user has obtained his permission roles through getInfo
    const routesAdded = store.getters.routesAdded
    if (routesAdded) {
      next()
    } else {
      try {
        // const accessRoutes = await store.dispatch('permission/generateRoutes')
        const accessRoutes = await store.dispatch('permission/filterRouters')
        // dynamically add accessible routes
        router.addRoutes(accessRoutes)

        // hack method to ensure that addRoutes is complete
        // set the replace: true, so the navigation will not leave a history record
        next({ ...to, replace: true })
      } catch (error) {
        // remove token and go to login page to re-login
        await store.dispatch('user/resetToken')
        Message.error(error || 'Has Error')
        redirectToLogin(next, to)
      }
    }
  } else {
    /* has no token*/

    if (whiteList.has(to.path)) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      redirectToLogin(next, to)
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
